import React, { useState, useRef } from 'react';
import Popup from '../../Popup';
import styles from './shareUrlPopup.scss';

const ShareUrlPopup = props => {
    const {
        title,
        subtitle,
        text,
        url,
        hideButton,
        isDraft,
        closeBtnTxt,
        onCloseClick,
        onSubmit,
        linkCopied,
    } = props;

    const [displayCopied, setDisplayCopied] = useState(false);
    const inputRef = useRef(null);

    const fallbackCopyText = () => {
        const isIphone = navigator.userAgent.match(/ipad|iphone/i);
        if (inputRef) {
            let range; let
                selection;
            if (isIphone) {
                range = document.createRange();
                range.selectNodeContents(inputRef.current);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                inputRef.current.setSelectionRange(0, 999999);
            } else {
                inputRef.current.select();
            }
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error(err);
            }
        }
        setDisplayCopied(true);
        if (linkCopied) {
            linkCopied();
        }
    };

    const copyTextToClipboard = (copyText) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(copyText).then(() => {
                setDisplayCopied(true);
                if (linkCopied) {
                    linkCopied();
                }
            }, (err) => {
                console.error('Async: Could not copy text: ', err);
                setDisplayCopied(false);
            });
        } else {
            fallbackCopyText();
        }
    };

    const handleSubmitClick = () => {
        if (onSubmit) {
            onSubmit();
        }
    };

    return (
        <Popup
            className="popup-sm"
            popUpClassName={`${styles.shareUrlPopup}`}
            onCloseClick={onCloseClick}
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                style: {
                    height: 'auto',
                },
            }}
            data-testid="modal.share-url"
        >
            <div className="popup-section p24 pt0">
                <h5 data-testid="modal.share-url.title">{title}</h5>
                <span className="text-gray" data-testid="modal.share-url.subtitle">{subtitle}</span>
            </div>
            <div className="popup-section popup-section-gray p24">
                <div className={`link-area`}>
                    <form>
                        {text && <div className={`link-title`} data-testid="modal.share-url.text">{text}</div>}
                        <div className={`form-group mb0`}>
                            <div className="input-group">
                                <input
                                    type="text"
                                    id="url"
                                    className="form-control"
                                    value={url || `${window.location.href}`}
                                    ref={inputRef}
                                    readOnly={false}
                                    contentEditable={true}
                                    data-testid="modal.share-url.url-input"
                                />
                                <div className="input-group-append">
                                    <button
                                        type="button"
                                        className={`btn btn-large btn-block btn-sq ${displayCopied ? 'btn-default' : 'btn-primary'} d-block text-uppercase`}
                                        onClick={() => {
                                            if (!displayCopied) {
                                                copyTextToClipboard(url || window.location.href);
                                            }
                                        }}
                                        disabled={displayCopied}
                                        data-testid="modal.share-url.copy-btn"
                                    >
                                        <i className="fas fa-copy" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                {!hideButton && (
                    <>
                        <div className="text-center lh32 text-gray" data-testid="modal.share-url.or-divider">or</div>
                        <div className="row mt24">
                            <div className="col-12 ">
                                {isDraft ? (
                                    <button
                                        type="button"
                                        className={`btn btn-primary text-uppercase btn-block`}
                                        disabled={true}
                                        data-testid="modal.share-url.submit-btn"
                                    >
                                        {closeBtnTxt}
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className={`btn btn-primary text-uppercase btn-block`}
                                        onClick={handleSubmitClick}
                                        data-testid="modal.share-url.submit-btn"
                                    >
                                        {closeBtnTxt}
                                    </button>
                                )}

                            </div>
                        </div>
                    </>
                )}
            </div>
        </Popup>
    );
};

export default ShareUrlPopup;
